import EditWishlistItemPage from "./EditWishlistItemPage";
export default EditWishlistItemPage;